import { KeyValue } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { isStringArray } from "../utils/string-utils";

@Pipe({ name: 'KeyValue'})
export class KeyValuePipe implements PipeTransform {
  transform(key: string | string[], dataList: string | KeyValue<string, any>[], elements?: string) : string {
    if(typeof dataList === 'string') {
      if(dataList && elements) {
        const elementsObj: {[datalistName: string]: KeyValue<string, string>[]} = JSON.parse(elements);
        const elementsOfDataList = elementsObj[dataList];
    
        return this.getValue(key, elementsOfDataList);
      }
      return key as string;
    } else {
      return this.getValue(key, dataList);
    }
  }

  private getValue(key: string | string[], elements: KeyValue<string, any>[]) {
    const keys = Array.isArray(key) 
        ? key
        : isStringArray(key)
          ? JSON.parse(key as string)
          : [key];
    return keys.map(k => elements?.find(element => element.key == k)?.value || '').join(", ");
  }

}